import { all, fork } from 'redux-saga/effects';
import listSurveysByUserId from './list-surveys-by-user-id';
import submitSurvey from './submit-survey';
export default function* surveySaga() {
    yield all([fork(listSurveysByUserId), fork(submitSurvey)]);
}
